import { SearchQueryOptions } from '~/models/SearchQuery';
import ContensisRepository from '~/repositories/ContensisRepository';

export const transformQueryForTarget = (
  contensis: ContensisRepository
): SearchQueryOptions => {
  const includeIds = contensis.query?.includeIds?.map((id) =>
    contensis.transformGuid(id)
  );

  const transformedQuery = { ...(contensis.query || {}), includeIds };

  return transformedQuery;
};
